/* eslint-disable */
export default {
  IncreaseBid: 'IncreaseBid',
  DecreaseBid: 'DecreaseBid'
};

